// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home-Index.vue';
import Hangtag from '../views/tools/Hang-Tag.vue';
import Img2Video from '../views/tools/Img2Video.vue';
import TestPage from '../views/tools/TestPage.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '首页' } // 添加 meta 字段
  },
  {
    path: '/hangtag',
    name: 'Hangtag',
    component: Hangtag,
    meta: { title: '吊牌工具' } // 添加 meta 字段
  },
  {
    path: '/img2video',
    name: 'Img2Video',
    component: Img2Video,
    meta: { title: '图片合成视频' } // 添加 meta 字段
  }
  ,
  {
    path: '/testpage',
    name: 'TestPage',
    component: TestPage,
    meta: { title: '测试页面' } // 添加 meta 字段
  }
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL || '/'), // 使用 VUE_APP_BASE_URL
  routes
});

// 使用导航守卫更新浏览器标题
router.beforeEach((to, from, next) => {
  // 如果路由有 meta.title，则设置为浏览器标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;